// Choisit le meilleur résultat parmi les détections brutes d'un lecteur (natif ou ZXing) : un cadre
// peut contenir plusieurs codes-barres (ex. code interne + EAN sur un même emballage), on privilégie
// celui qui a la forme d'un EAN-13/EAN-8/UPC-A. Fichier séparé de `scanner.ts` pour rester testable
// sans tirer l'import WASM de ZXing (voir test/selectEan.test.ts).
import type { BarcodeDetection } from './types.js';

const EAN_SHAPE = /^\d{8}$|^\d{12,13}$/;

export function selectEan(detections: readonly BarcodeDetection[]): string | null {
  const eanShaped = detections.find((d) => EAN_SHAPE.test(d.rawValue));
  return eanShaped?.rawValue ?? detections[0]?.rawValue ?? null;
}
